import React from 'react';
import AdvertisingSell from '../components/advertising/AdvertisingSell';
import ExperienceCarousel from '../components/carusel/ExperienceCarousel';
import AdvertisingBuy from '../components/advertising/AdvertisingBuy';
import PayOff from '../components/carusel/PayOff';
import NewsLetter from '../components/newsLetter/NewsLetter';
import TrainCarousel from '../components/carusel/TrainCarousel';
import FlightCarousel from '../components/carusel/FlightCarousel';
import RoomCarousel from '../components/carusel/RoomCarousel';
import ZendeskChat from '../components/chat/ZendeskChat';
import SEO from '../components/SEO';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import FAQJsonLd from '../components/FAQJsonLd';

const Home = () => {
  const location = useLocation();
  const showZendesk = !location.pathname.includes('customer-care');

  return (
    <>
      <SEO
        title="Il primo marketplace al mondo per rivendere hotel, treni e aerei - Save Your Travel"
        description="Non puoi più partire? Rivendi il tuo viaggio su Save Your Travel. Organizza le tue vacanze in modo semplice e conveniente con Save Your Travel: prenota biglietti aerei, treni e hotel per vivere esperienze uniche in ogni destinazione."
        keywords={[
          "Imprevisto",
          "Viaggio annullato",
          "Rivendita viaggi",
          "Treni",
          "Vendita biglietti Aerei",
          "hotel",
          "Cambio di piani",
          "Piattaforma viaggi",
          "Annunci viaggi",
          "Marketplace viaggi"
        ]}
        frequency="daily"
        priority="1"
      />
      <FAQJsonLd />
      <div className="w-full lg:p-6">
        <AdvertisingSell />
        <RoomCarousel />
        <TrainCarousel />
        <FlightCarousel />
        <AdvertisingBuy />
        <ExperienceCarousel />
        <PayOff />
        <NewsLetter />
        {showZendesk && <ZendeskChat />}
      </div>
    </>
  );
};

export default Home;
